<template>
    <div class="chooseCompany">
        <div class="choose_content">
            <p class="choose_title">请选择您要登入的公司</p>
            <ul class="choose_select">
                <li
                        v-for="(item,index) in companylist"
                        :key="index"
                        @click="chooseCompany(item,index)"
                >{{item.name}}
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
  export default {
    name: '',
    data () {
      return {
        companylist: []
      }
    },
    components: {},
    mounted: function () {
      this.getcompanyList()
    },
    methods: {
      getcompanyList: function () {
        var self = this
        this.global.axiosGet(self, 'employments/', function (res) {
          self.companylist = res
          // 如果只有一個公司 直接進入該公司下
          console.log(res.length)
          if (res.length == 1) {
            self.$router.push({
              name: 'homepage',
              params: { id: res[0].id }
            })
            localStorage.setItem('companyInfo', JSON.stringify(res[0]))
          }
        })
      },
      chooseCompany: function (item, index) {
        var id = item.id
        localStorage.setItem('companyInfo', JSON.stringify(item))
        this.$router.push({ name: 'homepage', params: { id: id } })
      }
    }
  }
</script>
<style scoped>
    .chooseCompany {
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background: url("/static/chooseCompany.png") no-repeat center center;
        background-size: 100% 100%;
        text-align: center;
        font-size: 0;
        white-space: nowrap;
        overflow: auto;
    }

    .chooseCompany:after {
        content: "";
        display: inline-block;
        height: 100%;
        vertical-align: middle;
    }

    .choose_content {
        display: inline-block;
        vertical-align: middle;
        text-align: left;
        font-size: 14px;
        white-space: normal;
        background: rgba(0, 0, 0, 0.2);
        padding: 20px;
    }

    .choose_title {
        font-size: 30px;
        color: #fff;
    }

    .choose_select {
        margin: 0;
        padding: 0;
    }

    .choose_select li:first-child {
        margin-top: 20px;
    }

    .choose_select li {
        font-size: 20px;
        text-align: center;
        list-style: none;
        line-height: 49px;
        background: rgba(255, 255, 255, 0.5);
        margin-bottom: 20px;
        color: #333;
    }
</style>



// WEBPACK FOOTER //
// src/views/chooseCompany/chooseCompany.vue